exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".layout-modal-body{padding:20px}.layout-modal-footer{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;padding:0 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/reports/shared/components/report-variant-modals/index.scss
// module id = 5203
// module chunks = 0